/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

export const ErrorAlert = {

    init(showFunction, hideFunction) {
        this.show = showFunction;
        this.hide = hideFunction;
    },

    show(appendToChildren, title) {
        //overriden on init
    },

    hide() {
        //overriden on init
    }
};